<div class="gcontainer report-thermal-wrapper">
  <div id="drawer" class="drawer-wrapper" [ngClass]="{ 'drawer-active': drawerActive }">
    <div class="drawer-content">
      <div class="drawer-head">
        <span class="t">Figures</span>
        <button mat-icon-button class="close-button" (click)="closeNav()">
          <mat-icon>close</mat-icon>
        </button>
      </div>
      <div class="spacer"></div>
      <div class="figure-wrapper">
      </div>
    </div>
  </div>
  <div class="col-md-11">
    <nav aria-label="breadcrumb" class="mt-8">
      <ol class="breadcrumb">
        <li class="breadcrumb-item active breadcrumb cursor" aria-current="page">
          <a class="c-primary" [routerLink]="'/dashboard'" tabindex="0"> Dashboard </a>
        </li>
        <li class="breadcrumb-item active" aria-current="page">
          <a
            class="c-primary"
            [routerLink]="['/report/edit', soilType, projectId]"
            [queryParams]="{ edit: 'true' }"
            tabindex="0">
            Edit Report
            @if (companyName) {
              <span> - {{ companyName }}</span>
            }
            @if (projectName) {
              <span> - {{ projectName }}</span>
            }
            @if (soilType === 'precast') {
              <span> - Pre Cast</span>
            }
            @if (soilType === 'nativesoil') {
              <span> - Native Soil</span>
            }
          </a>
        </li>
      </ol>
    </nav>
  </div>
  <div class="report-thermal-content-wrapper" [ngClass]="{ 'nav-collapsed': !figureNavOpen }">
    @if (numberOfFigures > 0) {
      <button
        type="button"
        class="figure-nav-toggle"
        (click)="toggleFigureNav()"
        [attr.aria-expanded]="figureNavOpen"
        [attr.aria-label]="figureNavOpen ? 'Hide figures list' : 'Show figures list'">
        <mat-icon>{{ figureNavOpen ? 'chevron_left' : 'chevron_right' }}</mat-icon>
      </button>
    }
    @if (numberOfFigures > 0 && figureNavOpen) {
      <nav class="figure-nav-list" aria-label="Figures">
        <div class="figure-nav-title">Figures</div>
        @for (figure of figures; track figure; let i = $index) {
          <button
            type="button"
            class="figure-nav-item"
            [ngClass]="{ active: i === pageIndex }"
            (click)="goToFigure(i)">
            <span class="fn-label">Figure {{ i + 1 }}</span>
          </button>
        }
      </nav>
    }
    <div class="left-t-content-wrapper">
      <h1>Thermal Resistivity Report</h1>
      <div class="points-panel">
        @for (sample of currentFigure?.precastFigureSamples; track sample; let sampleIndex = $index) {
          <div
            class="curve-section"
            [style.--curve-color]="getCurveColor(sampleIndex)">
            <div class="curve-section-header">
              <h3 class="curve-section-title">{{ sample.sampleLabel }}</h3>
            </div>
            @if (!sample.hideAll && !sample.hideActual) {
              @for (curve of sample.curves; track curve; let curveIndex = $index) {
                <div class="curve">
                  <div class="curve-main">
                    <h4 class="curve-label">
                      {{ curve.curveLabel }}
                    </h4>
                    <div class="curve-points">
                      <div class="point-axis-labels">
                        <span class="axis-label">Moisture</span>
                        <span class="axis-label">TR</span>
                      </div>
                      @for (point of curve.curve; track point; let i = $index; let first = $first; let last = $last) {
                        @if (i > 0 && canAddPoint(sampleIndex, curveIndex)) {
                          <button
                            type="button"
                            class="add-point-between-btn"
                            (click)="addPointBetween(sampleIndex, curveIndex, i - 1)"
                            aria-label="Add point between">
                            +
                          </button>
                        }
                        <div class="point-container">
                          <input type="number" [value]="point.moistureContent" (change)="updatePoint(sampleIndex, curveIndex, i, 'x', $event)" [readonly]="first || last" />
                          <input type="number" [value]="point.tr" (change)="updatePoint(sampleIndex, curveIndex, i, 'y', $event)" />
                          @if (!first && !last) {
                            <button
                              type="button"
                              class="delete-point-btn"
                              (click)="deletePoint(sampleIndex, curveIndex, i)"
                              aria-label="Delete point">
                              −
                            </button>
                          }
                        </div>
                      }
                    </div>
                  </div>
                  <mat-checkbox
                    class="average-checkbox"
                    [checked]="curve.average"
                    (change)="toggleCurveAverageSelection(sampleIndex, curveIndex)">
                    Average
                  </mat-checkbox>
                </div>
              }
            }
            @if (!sample.hideAll && !sample.hideAverage && (sample.averageCurve?.length || sample.historicalCurvePoints?.length)) {
              <div class="curve average-curve">
                @if (sample.averageCurve?.length) {
                  <div class="curve-main">
                    <h4 class="curve-label">Average</h4>
                    <div class="curve-points">
                      <div class="point-axis-labels">
                        <span class="axis-label">Moisture</span>
                        <span class="axis-label">TR</span>
                      </div>
                      @for (point of sample.averageCurve; track point) {
                        <div class="point-container readonly">
                          <input type="number" [value]="point.moistureContent" readonly disabled />
                          <input type="number" [value]="point.tr" readonly disabled />
                        </div>
                      }
                    </div>
                  </div>
                }
                @if (sample.historicalCurvePoints?.length) {
                  <button
                    type="button"
                    class="historical-points-btn"
                    (click)="openHistoricalCurvePoints(sampleIndex)">
                    <mat-icon>history</mat-icon>
                    <span>Show historical data points</span>
                  </button>
                }
              </div>
            }
            <div class="curve-section-actions">
              <button
                type="button"
                class="sample-visibility-toggle"
                (click)="toggleSampleVisibility(sampleIndex)"
                [attr.aria-pressed]="sample.hideAll"
                [attr.aria-label]="sample.hideAll ? 'Show all curves' : 'Hide all curves'">
                <mat-icon>{{ sample.hideAll ? 'visibility_off' : 'visibility' }}</mat-icon>
                <span>{{ sample.hideAll ? 'Show' : 'Hide' }} all</span>
              </button>
              <button
                type="button"
                class="sample-visibility-toggle"
                (click)="toggleActualCurves(sampleIndex)"
                [attr.aria-pressed]="sample.hideActual"
                [attr.aria-label]="sample.hideActual ? 'Show actual curves' : 'Hide actual curves'">
                <mat-icon>{{ sample.hideActual ? 'visibility_off' : 'visibility' }}</mat-icon>
                <span>{{ sample.hideActual ? 'Show' : 'Hide' }} actual curves</span>
              </button>
              <button
                type="button"
                class="sample-visibility-toggle"
                (click)="toggleAverageCurve(sampleIndex)"
                [attr.aria-pressed]="sample.hideAverage"
                [attr.aria-label]="sample.hideAverage ? 'Show average curve' : 'Hide average curve'">
                <mat-icon>{{ sample.hideAverage ? 'visibility_off' : 'visibility' }}</mat-icon>
                <span>{{ sample.hideAverage ? 'Show' : 'Hide' }} average curve</span>
              </button>
            </div>
          </div>
        }
      </div>
    </div>
    <div class="right-t-content-wrapper" [style.width.px]="chartBoxWidthPx">
      <label class="project-location-input">
        <span class="project-location-label">Project Location</span>
        <input type="text" [value]="projectLocation" readonly />
      </label>
      @if (currentFigure; as figure) {
        <div class="scale-inputs">
          <label class="scale-input">
            <span class="scale-label">Max X</span>
            <input
              type="number"
              [value]="figure.maxX"
              [min]="15"
              [step]="5"
              (change)="onMaxXChange($event)" />
            </label>
            <label class="scale-input">
              <span class="scale-label">Max Y</span>
              <input
                type="number"
                [value]="figure.maxY"
                [min]="isMetricValue ? 1.5 : 150"
                [step]="isMetricValue ? 0.5 : 50"
                (change)="onMaxYChange($event)" />
              </label>
              <button
                mat-raised-button
                type="button"
                class="apply-all-button"
                (click)="applyScaleToAllFigures()">
                Apply to all figures
              </button>
            </div>
          }
          @if (currentFigure?.requirements?.length) {
            <div class="figure-requirements">
              @for (requirement of currentFigure.requirements; track requirement) {
                <div class="figure-requirement">
                  {{ requirement }}
                </div>
              }
            </div>
          }
          <div class="canvas-wrapper" [style.width.px]="chartWidthPx" [style.height.px]="chartHeightPx">
            <canvas baseChart
              [data]="chartData"
              [options]="chartOptions"
              [type]="'line'"
              [width]="chartWidthPx"
              [height]="chartHeightPx">
            </canvas>
          </div>
        </div>
        <div class="clearfix"></div>

      </div>

      <div class="thermal-page-button-wrapper">
        <div class="button-left">
          <button mat-raised-button (click)="prev()" [disabled]="prevDisabled">
            <mat-icon>navigate_before</mat-icon>
            PREV
          </button>
          <button mat-raised-button [routerLink]="['/report/edit/precast', projectId]" [queryParams]="{ edit: 'true' }">
            BACK TO REPORT
          </button>
        </div>
        <div class="button-right">
          <button mat-raised-button (click)="previewGraphs()">PREVIEW GRAPHS</button>
          <button mat-raised-button (click)="openFigureOrderingPopup()">ARRANGE FIGURES</button>
          <button mat-raised-button color="primary" (click)="onSubmit()">SAVE</button>
          <button mat-raised-button class="c-next" (click)="next()" [disabled]="nextDisabled">
            NEXT<mat-icon>navigate_next</mat-icon>
          </button>
        </div>
        <div class="clearfix"></div>
      </div>

      @if (figureOrderingPopupOpen) {
        <app-precast-figure-ordering-popup
          [figures]="figures"
          [numberOfFigures]="numberOfFigures"
          [projectID]="projectId"
          (save)="saveFigureOrdering($event)"
          (cancel)="closeFigureOrderingPopup()">
        </app-precast-figure-ordering-popup>
      }
    </div>
